module.exports = __webpack_public_path__ + "img/isp-protezione-nobg.2bc97683.png";